import cx from 'classnames';

import s from './index.module.css';
import { IStickyFooterProps } from './types';

const StickyFooter = ({ children, className, wrapperClassName }: IStickyFooterProps) => (
  <div className={cx(s.wrapper, wrapperClassName)} data-id="stickyFooterWrapper">
    <div className={cx(s.stickyFooter, className)}>{children}</div>
  </div>
);

export default StickyFooter;
